import { DeliveryContext } from '@CONTEXTS';
import { useContext } from 'react';
import Filters from './filters';
import Table from './table';
import PrintModal from './print-modal';
import UpdateModal from './update-modal';

const PreOrder = () => {
  const { printModal, updateModal } = useContext(DeliveryContext);
  return (
    <>
      {printModal && <PrintModal />}
      {updateModal && <UpdateModal />}
      <div className="app-content-header">
        <div style={{ width: '100%', padding: '12px 24px' }}>
          <Filters />
        </div>
      </div>
      <div className="nav-page-content">
        <div className="app-deliveries"></div>
        <Table />
      </div>
    </>
  );
};

export default PreOrder;
